/**
 * 环境名
 * @returns  开发环境(inside)  测试环境(test) 现网环境('')
 */
// eslint-disable-next-line import/no-mutable-exports
let ENV_NAME = ''
const wxAppId = wx.getAccountInfoSync().miniProgram.appId
switch (wxAppId) {
  case 'wx0c3417205d9852a9': // 主干环境
    ENV_NAME = 'inside'
    break
  case 'wxb58a41ffda339bf5': // 测试环境
    ENV_NAME = 'test'
    break
  case 'wx13a74d0d3ab0942e': // 正式环境
    ENV_NAME = ''
    break
  default:
    break
}

const storeId = wx.getStorageSync('storeId') || 'appmzd7lhrj6214'

// 鹅直播基础域名
const LIVE_BASE_URL = `https://applet-server${ENV_NAME ? `.${ENV_NAME}` : ''}.xiaoeknow.com/`
const PLAYER_BASE_URL = `https://${storeId}.h5${ENV_NAME ? `.${ENV_NAME}` : ''}.xiaoeknow.com/`

export {
  LIVE_BASE_URL,
  PLAYER_BASE_URL,
  ENV_NAME
}
